<script setup lang="ts">
import { gaiaNeutral } from '@/components/design/themes/tokens';
import logoUrl from '@/assets/logo.svg';

/**
 * The Office add-in's sign-in shell — AuthLayout's mark-above-the-card form,
 * sized for a task pane. There is no brand panel here: the pane is a narrow
 * column and the person opening it has already chosen GAIA by installing the
 * add-in, so the marketing headline would be selling to someone who has
 * already bought. The page supplies only its card, exactly as on the web.
 */
const canvas = gaiaNeutral.surfaceCanvas;
</script>

<template>
  <div class="office-auth-layout" :style="{ background: canvas }">
    <img :src="logoUrl" alt="GAIA" class="logo" />
    <div class="card-slot">
      <router-view />
    </div>
  </div>
</template>

<style scoped>
/* The column is the whole pane: the card centres against the viewport and sits
   a little above the optical centre, as on the web auth screens. */
.office-auth-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 14px 48px;
}

.logo {
  height: 20px;
  width: auto;
  display: block;
  margin-bottom: 22px;
}

.card-slot {
  width: 100%;
  max-width: 440px;
}
</style>
